// GET /permissions gives config[key].authType for a standalone page and config[group][key].authType
// for a page inside a menu group.
export const pageRoles = (config, group, key) => {
  const entry = group ? config[group] && config[group][key] : config[key];
  return (entry && entry.authType) || [];
};

// legacyKey keeps a page that moved into a group open to roles that only have its old standalone permission.
export const canOpenPage = (config, roles, { group, key, legacyKey }) =>
  [...pageRoles(config, group, key), ...(legacyKey ? pageRoles(config, null, legacyKey) : [])].some((role) =>
    roles.includes(role)
  );
